export default __webpack_public_path__ + "static/fininscase2-764ac3dd3e42a26c372d795998e70779.png";